<template>
	<JFlex class="s-flex-wrap s-p-4">
		<!-- Display CSS handlers-->
		<JBox class="s-w-full" v-if="internalNode.attrsMap">
			<InspectorTailwindCss class="s-mb-12" v-model="internalNode.attrsMap.class" :theme="theme" @input="putNode" />
		</JBox>

		<!-- Style -->
		<JBox class="s-w-full s-mt-8" v-if="internalNode.attrsMap">
			<JBox class="s-font-semibold s-text-xs s-uppercase s-text-gray-600">
				{{ $t("uiEditor.style") }}
			</JBox>
			<JInputLongText v-model="internalNode.attrsMap.style" />
		</JBox>

		<!-- Classes -->
		<JBox class="s-w-full s-mt-8" v-if="internalNode.attrsMap">
			<JBox class="s-font-semibold s-text-xs s-uppercase s-text-gray-600">
				Class
			</JBox>
			<JInputLongText v-model="internalNode.attrsMap.class" />
		</JBox>
	</JFlex>
</template>

<script>
import InspectorTailwindCss from "./InspectorTailwindCss"

export default {
	components: { InspectorTailwindCss },
	data() {
		return {
			internalNode: {}
		}
	},

	computed: {
		theme() {
			return JSON.parse(this.$store?.state?.uiEditor?.app?.themeJsonString ?? {})
		}
	},

	methods: {
		putNode() {
			this.$store.dispatch("uiEditor/putNode", this.internalNode)
		}
	},

	watch: {
		"$store.state.uiEditor.selectedNodeIds": {
			handler() {
				this.internalNode = this.$store.getters["uiEditor/selectedNode"]
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
